<template>
  <div class="level" style="width: 100%;">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ $t("m.xiangqing") }}</p>
    </div>
    <div
      class="level_con"
      :class="select ? 'level_con1' : ''"
      :style="{ width: ceshi }"
      v-if="detailData"
      @click="double"
    >
      <div style="display: flex; align-items: center; flex-flow: column;">
        <h1
          style="font-size: 0.36rem;margin-bottom:10px;text-align:center;;width: 100%;"
        >
          {{ detailData.title }}
        </h1>
        <div
          style="width: 100%; display: flex; justify-content: space-between; margin: 5px 0 15px 0; font-size: 12px; color: #999"
        >
          <!--          <span>{{$t('m.fx_span3')}}</span>-->
        </div>
      </div>
      <img
        v-if="detailData.image"
        :src="detailData.image"
        class="detailImage"
      />
      <div v-html="detailData.content" class="content"></div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import { getArticleDetails } from "../../api/public";
import { goodsImage, rewriteHtmlAssets } from "@utils/goodsImage";
import Icon from "vant/lib/icon";
// import Toast from "vant/lib/toast";
// import "vant/lib/toast/style";
import "vant/lib/icon/style";
export default {
  name: "detail",
  data() {
    return {
      ceshi: "100%",
      select: false,
      detailData: null
    };
  },
  components: {
    Icon
  },
  methods: {
    double() {
      this.select = !this.select;

      console.log("栓合计");
    }
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return h + ":" + m + ":" + s;
      };
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      this.$router.go(-1);
    } else {
      getArticleDetails(this.$route.query.id)
        .then(res => {
          console.log(res);
          this.detailData = res.data.data || {};
          this.detailData.image = goodsImage(this.detailData.image);
          this.detailData.content = rewriteHtmlAssets(this.detailData.content);
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    }
  }
};
</script>

<style scoped>
.level_con1 >>> img {
  max-width: 200% !important;
}
.level_con1 >>> .content img {
  max-width: 250% !important;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  width: 100%;
  overflow-x: scroll;
  margin-top: 50px;
  padding: 15px;
}
.detailImage {
  max-width: 100%;
  border-radius: 5px;
  display: inline-block;
  height: auto;
}
.content >>> img {
  max-width: 100% !important;
  display: inline-block !important;
  height: auto !important;
}
</style>
